// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.all-products-offerlist {
  height: calc(97vh - 72px);
  overflow-y: scroll;
  padding: 20px;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.all-products-offerlist::-webkit-scrollbar {
  width: 6px;
}

.all-products-offerlist::-webkit-scrollbar-track {
  background: transparent;
}

.all-products-offerlist::-webkit-scrollbar-thumb {
  background: #cbd5e1; /* slate-300 */
  border-radius: 9999px;
}

.all-products-offerlist::-webkit-scrollbar-thumb:hover {
  background: #94a3b8; /* slate-400 */
}

.all-products-offerlist > div {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* ── Offers panel header ──────────────────────────── */
.offers-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px; /* px-5 py-4 */
  border-bottom: 1px solid #f1f5f9; /* border-slate-100 */
  background: linear-gradient(135deg, rgba(255, 251, 235, 0.96), rgba(255, 255, 255, 0.92));
}

.offers-panel-supertitle {
  display: block;
  font-size: 11px !important;
  font-weight: 600;
  color: #6b7280;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  margin-bottom: 2px;
}

.offers-panel-title {
  margin: 0;
  font-size: 20px !important; /* text-xl */
  font-weight: 700;
  color: #0f172a; /* text-slate-900 */
  letter-spacing: -0.025em; /* tracking-tight */
  line-height: 1.2;
}

.offers-panel-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  border-radius: 9999px; /* rounded-full */
  padding: 4px 8px; /* keep existing button height */
  transition: all 0.15s;
  color: #64748b;
  font-size: 18px;
}

.offers-panel-close:hover {
  background: #f1f5f9;
  color: #0f172a;
}

.dark .offers-panel-title {
  color: #f3f4f6;
}

.dark .offers-panel-close:hover {
  background: #334155;
}
.dark .offers-panel-header {
  background: linear-gradient(135deg, rgba(30, 41, 59, 0.98), rgba(15, 23, 42, 0.95));
  border-bottom-color: #334155;
}
.dark .offers-panel-supertitle {
  color: #94a3b8;
}
.dark .all-products-offerlist {
  scrollbar-color: #334155 transparent;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/offers/offers.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB,EAAE,cAAc;EACnC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB,EAAE,cAAc;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB,EAAE,cAAc;EAClC,gCAAgC,EAAE,qBAAqB;EACvD,yFAAyF;AAC3F;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,0BAA0B,EAAE,YAAY;EACxC,gBAAgB;EAChB,cAAc,EAAE,mBAAmB;EACnC,wBAAwB,EAAE,mBAAmB;EAC7C,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,qBAAqB,EAAE,iBAAiB;EACxC,gBAAgB,EAAE,gCAAgC;EAClD,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,mFAAmF;EACnF,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA;EACE,oCAAoC;AACtC","sourcesContent":[".all-products-offerlist {\n  height: calc(97vh - 72px);\n  overflow-y: scroll;\n  padding: 20px;\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e1 transparent;\n}\n\n.all-products-offerlist::-webkit-scrollbar {\n  width: 6px;\n}\n\n.all-products-offerlist::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.all-products-offerlist::-webkit-scrollbar-thumb {\n  background: #cbd5e1; /* slate-300 */\n  border-radius: 9999px;\n}\n\n.all-products-offerlist::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8; /* slate-400 */\n}\n\n.all-products-offerlist > div {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* ── Offers panel header ──────────────────────────── */\n.offers-panel-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px; /* px-5 py-4 */\n  border-bottom: 1px solid #f1f5f9; /* border-slate-100 */\n  background: linear-gradient(135deg, rgba(255, 251, 235, 0.96), rgba(255, 255, 255, 0.92));\n}\n\n.offers-panel-supertitle {\n  display: block;\n  font-size: 11px !important;\n  font-weight: 600;\n  color: #6b7280;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  margin-bottom: 2px;\n}\n\n.offers-panel-title {\n  margin: 0;\n  font-size: 20px !important; /* text-xl */\n  font-weight: 700;\n  color: #0f172a; /* text-slate-900 */\n  letter-spacing: -0.025em; /* tracking-tight */\n  line-height: 1.2;\n}\n\n.offers-panel-close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  cursor: pointer;\n  border-radius: 9999px; /* rounded-full */\n  padding: 4px 8px; /* keep existing button height */\n  transition: all 0.15s;\n  color: #64748b;\n  font-size: 18px;\n}\n\n.offers-panel-close:hover {\n  background: #f1f5f9;\n  color: #0f172a;\n}\n\n.dark .offers-panel-title {\n  color: #f3f4f6;\n}\n\n.dark .offers-panel-close:hover {\n  background: #334155;\n}\n.dark .offers-panel-header {\n  background: linear-gradient(135deg, rgba(30, 41, 59, 0.98), rgba(15, 23, 42, 0.95));\n  border-bottom-color: #334155;\n}\n.dark .offers-panel-supertitle {\n  color: #94a3b8;\n}\n.dark .all-products-offerlist {\n  scrollbar-color: #334155 transparent;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
